import {v2Client} from './client'
const getSheets = (id) => v2Client.get(`/table/${id}/sheets`)
const getRows = (id, pagination) => v2Client.get(`/table/${id}/sheets/rows`, {params: pagination})
const getSelectedRows = (id, payload) => v2Client.post(`/table/${id}/sheets/selected-rows`, payload)
const checkDuplicateRows = (id, payload) => v2Client.post(`/table/${id}/sheets/checkDuplicateRows`, payload)
const exportSheet = (id) => v2Client.get(`/table/${id}/export`)
const all ={getSheets, getRows, checkDuplicateRows, exportSheet, getSelectedRows}
export default all